import React from 'react'
import brandLoader from '../../assets/images/brand-loader.gif'

const BkFlowLoader = props => {
  const {
    parentClasses,
    loadingSrc,
    loadingAlt
  } = props

  return (
    <div className={ parentClasses ? parentClasses : "u-brand-loader row center-xs" }>
      <img src={ loadingSrc ? loadingSrc : brandLoader } alt={ loadingAlt ? loadingAlt : "Brand Loading" } />
    </div>
  )
}

export default BkFlowLoader



// WEBPACK FOOTER //
// ./src/components/elements/BkFlowLoader.js